import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { IdleService } from '../services/idle.service';
import { SharedStateService } from '../services/shared-state.service';
import { LiveAnnouncer } from '@angular/cdk/a11y';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit {
    trackingID = '';


    constructor(
        private authService: AuthService,
        private idleService: IdleService, // Inject IdleService
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private sharedService: SharedStateService,
        private liveAnnouncer: LiveAnnouncer
      ) {}

  ngOnInit(): void {
    this.liveAnnouncer.announce('Logging in, please wait.');
    this.sharedService.clearAll();
    this.activatedRoute.paramMap.subscribe(params => {
        this.trackingID = params.get('token') || '';
        if (this.trackingID) {
          this.sharedService.changeState("trackingId", this.trackingID);
          this.authService.login(this.trackingID).subscribe({
            next:(response) => {
              const authToken = response.authToken;
              const paymentInfo = response.paymentInfo;
              const token = authToken.access_token;
              this.authService.setToken(token);
              this.authService.expiresIn = authToken.expires_in;
              this.sharedService.changeState("paymentInfo", paymentInfo);
              this.router.navigate(['/checkout']);
            },
            error:(error) => {
              this.router.navigate(['/expired']);
            }
          });
        }
    });
  }

}
